export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    meta: {
      resource: 'dashboard',
      action: ['read', 'update'],
    },
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: {
      resource: 'dashboard',
      action: ['read', 'update'],
    },
  },
  {
    path: '/dashboard/statistics',
    name: 'dashboard-statistics',
    component: () => import('@/views/dashboard/statistics/Statistic.vue'),
    meta: {
      resource: 'dashboard',
      action: ['read', 'update'],
    },
  },
  {
    path: '/dashboard/huay-dashboard',
    name: 'huay-dashboard',
    component: () => import('@/views/summary/HuayDashboard.vue'),
    meta: {
      resource: 'dashboard',
      action: ['read', 'update'],
    },
  },
  {
    path: '/dashboard/result',
    name: 'dashboard-result',
    component: () => import('@/views/dashboard/result/ResultDashboard.vue'),
    meta: {
      resource: 'dashboard',
      action: ['read', 'update'],
    },
  },
]
